import React from 'react'
import Page from "../Page";
export default class BiddingContractSubstep extends Page
{
	static TranslationKey;
    static SubstepName = '';

	static StepTitle = '';
	static StepInfo = '';

    static hasCompletedForProject(project) {
        return !(!project.acceptsStandardSOW() || !project.isBYO());
    }

    static getStepName(project) {
        return this.SubstepName;
    }

	constructor(props, context) {
        super(props, context);

        this.state = {
            ...this.state
        }
    }
	trans(key) {
		if(this.constructor.TranslationKey) {
			return TB.tryTrans(this.constructor.TranslationKey + '.' + key);
		}

		return key;
	}

	renderStepTitle() {
        if (this.props.project && (!this.props.project?.acceptsStandardSOW() || !this.props.project.isBYO())) {
            return null
        }

	    return (
	        <h3>
                {this.constructor.StepTitle}
            </h3>
        )
    }

	renderStepInfo() {
        if (this.props.project && (!this.props.project?.acceptsStandardSOW() || !this.props.project.isBYO())) {
            return null
        }

	    return (
	        <p>
                {this.constructor.StepInfo}
            </p>
        )
    }

    render()
    {
        let {project, forReview} = this.props;
        if (!project) {
            return <div/>
        }

        if (forReview) {
            return this.renderStepContent();
        }
        return (
            <div className="sow-approval-step">

                <div className="sow-approval-step-header">

                    {this.renderStepTitle()}
                    {this.renderStepInfo()}
                </div>

                {this.renderStepContent()}

            </div>
        );
    }

    renderStepContent()
    {
        return (
            <div>
                Placeholder Substep
            </div>
        );
    }
}
